import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AssistantPage } from '@/features/ai/rag/rag-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Projet → « Assistant documentaire » : les index du projet. */
export const Route = createFileRoute('/$tenant/projects/$projectId/assistant/')({
  component: AssistantRoute,
});

function AssistantRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="assistant"
      crumbs={[{ label: t('nav.items.assistant') }]}
    >
      <AssistantPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
